import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import AssessmentCard from "./AssessmentCard";
import classes from "./UserLandingPage.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { TextField } from "@mui/material";
import AttemptHistoryModal from "./quiz-attempt-history/AttemptHistoryModal";

const Assessments = ({ finalAssessments }) => {
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [showAttemptModal, setShowAttemptModal] = useState(false);

  const handleViewAttempts = (assessment) => {
    setSelectedAssessment(assessment);
    setShowAttemptModal(true);
  };

  const handleCloseAttemptModal = () => {
    setShowAttemptModal(false);
    setSelectedAssessment(null);
  };

  return (
    <>
      <AttemptHistoryModal
        show={showAttemptModal}
        handleClose={handleCloseAttemptModal}
        assessment={selectedAssessment}
      />
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between">
            <div className={classes.assessmentsHeader}>Assessments</div>
            {/* <div className={classes.arrowContainer}>
              <div className={classes.leftArrow}>
                <ArrowBackIosIcon />
              </div>
              <div className={classes.rightArrow}>
                <ArrowForwardIosIcon />
              </div>
            </div> */}
          </div>
          {/* <div className="mt-2">
            <TextField
              placeholder="Search Assessments"
              inputProps={{
                style: { height: "10px" },
              }}
            />
          </div> */}
          <Row className="mt-5">
            {finalAssessments.length > 0 ? (
              finalAssessments.map((assessment) => {
                return (
                  <>
                    <Col xl={4} lg={6} md={12} sm={12}>
                      <AssessmentCard assessment={assessment} onViewAttempts={handleViewAttempts} />
                    </Col>
                  </>
                );
              })
            ) : (
              <>
                <div>No Assessments Found</div>
              </>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default Assessments;
